export default "__VITE_ASSET__C0WQ_p8r__"